import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import http from "../../common/http-common";
import * as common from "../../common/common";
import * as Comp from "../../common/CommonComponents";
import { GetPagePermissionFn } from "../../common/authority";
import CssClass from "../../Styles/common.module.css";
import TicketPriorityTypeListTable from "../../components/MasterSetup/TicketPriorityType/TicketPriorityTypeListTable";
import RegisterTicketPriorityType from "../../components/MasterSetup/TicketPriorityType/RegisterTicketPriorityType";
import register from "../../assets/register-icon.png";
import exportIcon from "../../assets/export-icon.png";

const PAGE_NAME = "TicketPriorityType.js";
const MODULE_ID = "WEB_MAS_005";

const TicketPriorityType = (props) => {
  document.title = common.c_TITLE + " - Ticket Priority Type";

  const navigate = useNavigate();
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  const [searchData, setSearchData] = useState([]);
  const [allData, setAllData] = useState([]);

  const [dataToBeSelect, setDataToBeSelect] = useState([]);

  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");
  const [reload, setReload] = useState(false);

  const [showAdd, setShowAdd] = useState(false);

  const [actionAuthority, setActionAuthority] = useState({
    READ: "N",
    WRITE: "N",
  });

  useEffect(() => {
    let promise = GetPagePermissionFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setActionAuthority(result);
        if (result.READ === "N") {
          navigate("/Home");
        }
      },
      (error) => {
        setActionAuthority({
          READ: "N",
          WRITE: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPagePermissionFn", error);
        toast.error(error);
        navigate("/Home");
      }
    );
    }, [userId, navigate]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "useEffect Get All Ticket Priority Type";

        onLoadingHandler(true, "Getting Ticket Priority Type List, please wait...");

        setAllData([]);
        const listItems = [];
        http
          .get(
            "api/TicketPriorityType/GetAllTicketPriorityType?_userId=" + userId,
            { timeout: 10000000 }
          )
          .then((response) => {
            if (response.data.length > 0) {
              response.data.forEach((data, counter) => {
                listItems.push({
                  key: data.TICKET_PRIORITY_TYPE_ID,
                  TICKET_PRIORITY_TYPE_ID: data.TICKET_PRIORITY_TYPE_ID,
                  TICKET_PRIORITY_TYPE_NAME: data.TICKET_PRIORITY_TYPE_NAME,
                  REMARK: data.REMARK,
                  ACTIVE_FLAG: data.ACTIVE_FLAG,
                  STATUS: data.ACTIVE_FLAG === "Y" ? "Active" : "Inactive",
                  UPDATE_DATETIME: data.UPDATE_DATETIME,
                  UPDATE_ID: data.UPDATE_ID,
                  UPDATE_NAME: data.UPDATE_NAME,
                });
              });
            }
            setAllData(listItems);
          })
          .catch((err) => {
            toast.error(
              "Error on getting ticket priority type list. Please try again."
            );
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error(
          "Error on getting ticket priority type list. Please try again."
        );
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId]);

  //#region Event Handlers
  const showHideRegisterModal = () => {
    setShowAdd(!showAdd);
  };

  const onReloadHandler = () => {
    setReload(!reload);
  };

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };

  const onExcelHandler = () => {  
    window.open(common.c_getApiUrl() + "api/TicketPriorityType/ExportExcel?_user=" + userId);
  }
  //#endregion

  return (
    <>
      <Comp.Header>Ticket Priority Type</Comp.Header>
      <div className={CssClass.btnWrapper}>
        {actionAuthority.WRITE === "Y" && (
          <Comp.Button
            id="btnRegister"
            type="general"
            onClick={showHideRegisterModal}
          >
            REGISTER  <img src={register} alt="Register" style={{ width: "16px", height: "16px", marginBottom: "3px" }} />
          </Comp.Button>
        )}
        <Comp.Button id="btnExcel" type="excel" onClick={onExcelHandler}>
          EXPORT  <img src={exportIcon} alt="Export" style={{ width: "16px", height: "16px", marginBottom: "3px" }} />
        </Comp.Button>
      </div>
      <div className={`${CssClass.card} ${CssClass.tableCard}`}>
        {/* <h3 className={CssClass.tableTitle}>Ticket Priority Type list</h3> */}
        {/* <hr /> */}
        <TicketPriorityTypeListTable
          data={allData}
          onReload={onReloadHandler}
          page={PAGE_NAME}
          module={MODULE_ID}
          onLoading={onLoadingHandler}
          actionAuthority={actionAuthority}
        />
      </div>
      <RegisterTicketPriorityType
        showHide={showAdd}
        onHide={showHideRegisterModal}
        onReload={onReloadHandler}
        page={PAGE_NAME}
        module={MODULE_ID}
        onLoading={onLoadingHandler}
      />
      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
    </>
  );
};

export default TicketPriorityType;
